// --------------------------------------------------------------------------
// togglePassword.js
// --------------------------------------------------------------------------
// Toggles visibility of password input value
// --------------------------------------------------------------------------

RN.togglePassword = function() {

    'use strict';

    function init() {
        byBehaviour('toggle-password').on('click', togglePasswordVisibility);    
    }

    function togglePasswordVisibility() {
        var button = $(this),
            field = button.closest('.password-reveal').find('input');

        toggleFieldType(field);
        toggleTitleText(button);
    }

    function toggleFieldType(field) {
        if(field.attr('type') === 'password'){
            field.attr('type', 'text');
        }
        else{
            field.attr('type', 'password');
        }
    }

    function toggleTitleText(button) {
        if(button.attr('title') === 'Show password'){
            button.attr('title', 'Hide password');
        } 
        else{
            button.attr('title', 'Show password');
        }
    }

    return {
        init: init
    };

}();